import {Route, Routes} from 'react-router-dom'
import {AuthLayout} from './AuthLayout'
import {LoginPage} from "../../pages/auth/Login";

const AuthPage = () => (
    <Routes>
      <Route element={<AuthLayout/>}>
        <Route path='login' element={<LoginPage/>}/>
        <Route index element={<LoginPage/>}/>
      </Route>
    </Routes>
)

export {AuthPage}